import { requirePermissions } from '@/shared/utils';
import { TabsComponent } from '@noorden-insurtech/alba-design-system';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { Home } from 'lucide-react';
import { IntegrationsPage } from '../../../features/integrations/components/integrations-page.component';
import { PolicyBatchPage } from '../../../features/integrations/components/policy-batch-page.component';
import { Page, PageHeader } from '../../../shared/ui/page';

export const Route = createFileRoute('/_app/integrations/')({
  component: RouteComponent,
  beforeLoad: async () => {
    const hasPermission = await requirePermissions([
      'policies.integrations.read',
    ]);
    if (!hasPermission) {
      throw redirect({ to: '/dashboard' });
    }
  },
});

const tabs = [
  { value: 'emission-control', label: 'Controle de Emissão' },
  { value: 'policy-batch', label: 'Balde de Apólices' },
];

function RouteComponent() {
  return (
    <Page.Root>
      <Page.Breadcrumb
        items={[
          {
            label: 'Página Inicial',
            href: '/dashboard',
            iconLeft: <Home className='h-4 w-4' />,
          },
          { label: 'Integrações', active: true },
        ]}
      />

      <PageHeader.Root>
        <PageHeader.Main>
          <PageHeader.TitleGroup>
            <PageHeader.Title>Integrações</PageHeader.Title>
            <PageHeader.Subtitle>
              Acompanhe as integrações de emissão de apólices
            </PageHeader.Subtitle>
          </PageHeader.TitleGroup>
        </PageHeader.Main>
      </PageHeader.Root>

      <TabsComponent.Root defaultValue='emission-control' className='w-full mt-2'>
        <TabsComponent.List className='w-full flex'>
          {tabs.map(tab => (
            <TabsComponent.Trigger
              key={tab.value}
              value={tab.value}
              className='flex-1'
            >
              {tab.label}
            </TabsComponent.Trigger>
          ))}
          <TabsComponent.Indicator />
        </TabsComponent.List>

        <TabsComponent.Content value='emission-control'>
          <IntegrationsPage />
        </TabsComponent.Content>

        <TabsComponent.Content value='policy-batch'>
          <PolicyBatchPage />
        </TabsComponent.Content>
      </TabsComponent.Root>
    </Page.Root>
  );
}
